import { createSelector } from 'reselect';

const selectTasks = (state: any) => state.tasks;


export const selectCurrentItem = createSelector([selectTasks], (tasks) => tasks.current);

export const selectListItems = createSelector([selectTasks], (tasks) => tasks.list);

export const selectItemById = (itemId: any) =>
    createSelector(selectListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCreatedItem = createSelector([selectTasks], (tasks) => tasks.create);

export const selectUpdatedItem = createSelector([selectTasks], (tasks) => tasks.update);

export const selectReadItem = createSelector([selectTasks], (tasks) => tasks.read);

export const selectDeletedItem = createSelector([selectTasks], (tasks) => tasks.delete);

export const selectSearchedItems = createSelector([selectTasks], (tasks) => tasks.search);

export const selectItemsCount = createSelector([selectTasks], (tasks) => tasks.count);

export const selectItemsFilter = createSelector([selectTasks], (tasks) => tasks.filter);